"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _SessionDataConfig = _interopRequireDefault(require("./SessionDataConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function DataEntryTypePicker(_ref) {
  var selectedSessionType = _ref.selectedSessionType,
    setSelectedSessionType = _ref.setSelectedSessionType;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group",
    role: "group",
    style: {
      marginBottom: '2rem',
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(selectedSessionType === 'fixed' ? 'btn-primary' : 'btn-default'),
    onClick: function onClick() {
      return setSelectedSessionType('fixed');
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: '20rem'
    }
  }, "Fixed")), /*#__PURE__*/_react["default"].createElement("button", {
    disabled: true,
    type: "button",
    className: "btn ".concat(selectedSessionType === 'variable' ? 'btn-primary' : 'btn-default'),
    onClick: function onClick() {
      return setSelectedSessionType('variable');
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Under Development",
    type: "warning"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      minWidth: '20rem'
    }
  }, "Variable"))));
}
var _default = function _default(_ref2) {
  var assignmentData = _ref2.assignmentData,
    _ref2$assignmentData = _ref2.assignmentData,
    _ref2$assignmentData$ = _ref2$assignmentData.settings,
    navigationSettings = _ref2$assignmentData$.navigationSettings,
    _ref2$assignmentData$2 = _ref2$assignmentData$.navigationSettings.sessionType,
    sessionType = _ref2$assignmentData$2 === void 0 ? '' : _ref2$assignmentData$2,
    deploymentList = _ref2$assignmentData.deploymentList,
    closeModal = _ref2.closeModal;
  var _useState = (0, _react.useState)(sessionType || ''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedSessionType = _useState2[0],
    setSelectedSessionType = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(DataEntryTypePicker, {
    selectedSessionType: selectedSessionType,
    setSelectedSessionType: setSelectedSessionType
  }), selectedSessionType === 'fixed' && /*#__PURE__*/_react["default"].createElement(_SessionDataConfig["default"], {
    assignmentData: assignmentData,
    navigationSettings: navigationSettings,
    selectedSessionType: selectedSessionType,
    deploymentList: deploymentList,
    closeModal: closeModal
  }), selectedSessionType === 'variable' && /*#__PURE__*/_react["default"].createElement("div", null));
};
exports["default"] = _default;